export const getGroupDefaultValues = (groupId?: number | null) => {
  return {
    group: {
      id: groupId,
    },
  }
}
